import { UserOption } from "components/MultipleUserPicker";
import { HarmonizedViolationDefaultAssigneesQuery } from "generated-graphql/graphql";

import { assigneeDisplayName } from "./columns";

/** The drawer's one fetch of the current scope defaults, threaded to the popovers. */
export type ViolationDefaultAssignees =
  HarmonizedViolationDefaultAssigneesQuery["harmonizedViolationDefaultAssignees"];

/** All four scopes select the same user shape; the facility one stands in for them. */
type DefaultAssigneeUser = NonNullable<ViolationDefaultAssignees["facility"]>["user"];

/** A defaults-query user as a picker option, for prefilling a popover. */
export function toUserOption(user: DefaultAssigneeUser | undefined): UserOption | null {
  if (!user) return null;
  return { id: user.id, email: user.email, name: assigneeDisplayName(user) };
}

/** First selected user id from a single-select picker, or null when cleared. */
export function firstUserId(users: UserOption[] | null): string | null {
  return users && users.length > 0 ? (users[0]?.id ?? null) : null;
}
